module.exports = "<main>\n  <router-outlet></router-outlet>\n</main>\n<footer>\n  Made by BillGuard Alumni with <i class=\"fa fa-heart\"></i>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 431
// module chunks = 1